import React from 'react'
import { useRouter } from 'next/router'
import { MdKeyboardArrowRight } from 'react-icons/md'

import { CategoryItemFragment, ComponentPageDisplayOption } from '~/src/generated/graphql'
import { CONNECT_AVENUE_CATEGORY, CONNECT_FOUND_CATEGORY, CONNECT_JOBINFO_CATEGORY } from '~/src/const'
import { CategoryPosts, Button } from '~/src/components/shared'
import { AvenueLogo } from '~/src/components/connect'
import { PostCoverType } from '~/src/components/post/PostCard'
import { JobInfo } from '~/src/components/connect/JobInfo'

import styles from './ConnectContent.module.scss'

interface Props {
  category: CategoryItemFragment 
  displayOption?: ComponentPageDisplayOption | null
}

const AVENUE_FORM_LINK = 'https://forms.gle/egCs1ko96bEZeoRb9'
const FOUND_FORM_LINK = 'https://forms.gle/mVRLo6mYvw1P2Mip9'

export function ConnectSection({ category, displayOption }: Props) {
  const router = useRouter()

  const handleShowMore = (categoryId: string) => () => {
    router.push(`/categories/${categoryId}`)
  }

  const navigateGoogleForm = (link: string) => {
    window.open(link, '_blank')
  }

  if (category.categoryId === CONNECT_AVENUE_CATEGORY) {
    return (
        <>
          <CategoryPosts 
            category={category}
            coverType={PostCoverType.Square}
            showMore={false}
            displayOption={displayOption ?? undefined}
            headerProps={{
              title: <AvenueLogo /> 
            }}
          />
          <p className="my-8 text-center">
            <Button
              variant="primary"
              size='lg'
              className={styles.button}
              endIcon={<MdKeyboardArrowRight size="25" />}
              onClick={handleShowMore(category.categoryId)}>
                더보기 
            </Button>
            <Button
              variant="info"
              size='lg'
              className={styles.button}
              endIcon={<MdKeyboardArrowRight size="25" />}
              onClick={() => navigateGoogleForm(AVENUE_FORM_LINK)}>
                게시문의 
            </Button>
          </p>
        </>
    )
  }

  if (category.categoryId === CONNECT_FOUND_CATEGORY) {
    return (
      <>
        <CategoryPosts 
          category={category}
          coverType={PostCoverType.Square}
          showMore={false}
          displayOption={displayOption ?? undefined}
          headerProps={{
            variant: 'primary'
          }}
        />
        <p className="my-8 text-center">
          <Button
            variant="primary"
            size='lg'
            className={styles.button}
            endIcon={<MdKeyboardArrowRight size="25" />}
            onClick={handleShowMore(category.categoryId)}>
              더보기 
          </Button>
          <Button
            variant="info"
            size='lg'
            className={styles.button}
            endIcon={<MdKeyboardArrowRight size="25" />}
            onClick={() => navigateGoogleForm(FOUND_FORM_LINK)}>
              게시문의/음원접수
          </Button>
        </p>
      </>
    )
  }

  if (category.categoryId === CONNECT_JOBINFO_CATEGORY) {
    return (
      <div className="my-20" id="job-info" style={{ scrollMarginTop: 136 }}>
        <JobInfo />
      </div>
    )
  }

  return (
    <CategoryPosts
      key={category.categoryId}
      category={category}
      coverType={PostCoverType.Square}
      showMore
      displayOption={displayOption ?? undefined} />
  )
}